import o from "./visible.js";
import i from "./z-index.js";
import m from "./opacity.js";
import r from "./zooms.js";

function t(t, f) {
  o(t, f), i(t, f), m(t, f), r(t, f);
}

export default t;